export default function SectionApp() {
  return (
    <section id="app" className="bg-background-900 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-800/60 rounded-2xl p-8 md:p-12 border border-background-700/50">
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center shadow-2xl shadow-primary-500/30">
              <i className="ri-smartphone-line text-white text-5xl md:text-6xl"></i>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 mb-2">APP下载</h2>
            <p className="text-sm text-foreground-400 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              91麻豆免费视频网站移动客户端，随时随地免费视频在线观看。
              支持iOS与Android双平台，高清流畅播放体验，
              比网页端更稳定、更省流量，立即下载享受91免费视频网站的完整功能。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-700 hover:bg-background-600 text-foreground-200 border border-background-600 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}